import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=0b68ef0d&scoped=true"
import script from "./roles.vue?vue&type=script&lang=ts"
export * from "./roles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b68ef0d",
  null
  
)

export default component.exports